export default __webpack_public_path__ + "static/media/video1.2767d838.mp4";